import React from 'react';
export function ContactForm() {
  return <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-627">
      <h2 className="text-2xl font-bold text-white mb-6" data-id="element-628">Send a Message</h2>
      <form className="space-y-6" data-id="element-629">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-630">
          <div data-id="element-631">
            <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-632">
              First Name
            </label>
            <input type="text" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="John" data-id="element-633" />
          </div>
          <div data-id="element-634">
            <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-635">
              Last Name
            </label>
            <input type="text" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="Doe" data-id="element-636" />
          </div>
        </div>
        <div data-id="element-637">
          <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-638">
            Email Address
          </label>
          <input type="email" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="john@example.com" data-id="element-639" />
        </div>
        <div data-id="element-640">
          <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-641">
            Phone Number
          </label>
          <input type="tel" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="(555) 123-4567" data-id="element-642" />
        </div>
        <div data-id="element-643">
          <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-644">
            Message
          </label>
          <textarea rows={4} className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="How can we help you?" data-id="element-645" />
        </div>
        <button type="submit" className="w-full bg-[#00D4FF] text-black font-bold uppercase tracking-wider py-4 rounded-lg hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-646">
          Send Message
        </button>
      </form>
    </div>;
}